import externalLinks from '@config/external-links.json';
import routes from '@config/routes.json';

import { IFooterLinkItem } from './interfaces';

const oldCabinetLinks = JSON.parse(process.env.NEXT_PUBLIC_OLD_CABINET_LINKS);

export default {
    epn: [
        {
            key: 'Webmasters',
            id: 'FooterAffiliateLink',
            href: routes.home,
        },
        {
            key: 'Rules',
            id: 'FooterRulesLink',
            href: oldCabinetLinks.rules,
        },
        {
            key: 'Help',
            id: 'FooterHelpLink',
            href: oldCabinetLinks.help,
        },
        {
            key: 'Affiliate Programs',
            id: 'FooterPartnersLink',
            href: oldCabinetLinks.partners,
        },
        {
            key: 'EPN Affiliate',
            id: 'FooterAffiliateWebmasterLink',
            href: routes.cpa,
        },
        {
            key: 'Plugin',
            id: 'FooterPluginLink',
            href: routes.plugin,
        },
        {
            key: 'Telegram-bot',
            id: 'FooterTelegramBotLink',
            href: routes.telegramBot,
        },
        // {
        //     key: 'blog',
        //     id: 'FooterBlogLink',
        //     href: externalLinks.blog.info,
        //     isVisible: locale === LocaleTypes.ru,
        // },
        {
            key: 'Cashback',
            id: 'FooterCashbackLink',
            href: 'https://backit.me/:locale',
        },
        {
            key: 'API Documentation',
            id: 'FooterApiLink',
            href: externalLinks.apiDoc,
        },
        {
            key: 'Privacy',
            id: 'FooterPrivacyLink',
            href: oldCabinetLinks.privacy,
        },
    ],
    epncpa: [
        {
            key: 'Webmasters',
            id: 'FooterAffiliateLink',
            href: routes.home,
        },
        {
            key: 'Advertisers',
            id: 'FooterAffiliateWebmasterLink',
            href: routes.cpa,
        },
        {
            key: 'Rules',
            id: 'FooterRulesLink',
            href: oldCabinetLinks.rules,
        },
        {
            key: 'Confidentiality Policy',
            id: 'FooterPrivacyLink',
            href: oldCabinetLinks.privacy,
        },
    ],
}[process.env.NEXT_PUBLIC_PROJECT_NAME] as IFooterLinkItem[];
